import { render, staticRenderFns } from "./TeacherRequestDialog.vue?vue&type=template&id=5514f91d&scoped=true"
import script from "./TeacherRequestDialog.vue?vue&type=script&lang=js"
export * from "./TeacherRequestDialog.vue?vue&type=script&lang=js"
import style0 from "./TeacherRequestDialog.vue?vue&type=style&index=0&id=5514f91d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5514f91d",
  null
  
)

export default component.exports